const animated_number_counting = () => {
    window.addEventListener('scroll', () => {
        if ($('.about-us-details').length > 0) {
            let projectsSection = $(".about-us-details").offset().top + 300;
            let windowHeight = $(window).height();
            let scrollPosition = $(window).scrollTop();
            if (scrollPosition > (projectsSection - windowHeight)) {
                let headings = $("[data-number]");
                function increaseNumbers() {
                    let allReached = true;
                    headings.each(function () {
                        let data = parseInt($(this).data("number"));
                        let currentValue = parseInt($(this).text());
                        if (currentValue < data) {
                            allReached = false;
                            $(this).text(currentValue + 1 + "+");
                        }
                    });
                    if (!allReached) {
                        setTimeout(increaseNumbers, 75);
                    }
                }
                increaseNumbers();
            }
        }
    });
}

export default animated_number_counting;